import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/client";
import type { VoicemailPage } from "../../api/types";

/** New (unheard) voicemails, shared by the menu badge and desktop notifications (one request). */
export function useNewVoicemails(enabled: boolean) {
  return useQuery({
    queryKey: ["voicemails", "new-summary"],
    queryFn: () => get<VoicemailPage>("/voicemails?view=new&pageSize=10"),
    enabled,
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
  });
}
